import { render, staticRenderFns } from "./widthTitle1.vue?vue&type=template&id=f2385c12&scoped=true"
import script from "./widthTitle1.vue?vue&type=script&lang=js"
export * from "./widthTitle1.vue?vue&type=script&lang=js"
import style0 from "./widthTitle1.vue?vue&type=style&index=0&id=f2385c12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2385c12",
  null
  
)

export default component.exports